module.exports = __webpack_public_path__ + "img/sitem_bg2.699f1dfc.png";